import { faMagnifyingGlass as fasMagnifyingGlass } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import type { MeasureComponentProps, MeasureComponentState } from "@component/MeasureComponent";
import { MeasureComponent } from "@component/MeasureComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { EventComponentType } from "@utils/google-analytics-4.type";
import autobind from "autobind-decorator";
import { LazyLoad } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";

const SearchModal = React.lazy(() => import("./SearchModal"));

interface Props extends MeasureComponentProps {
	search?: string;
}

interface State extends MeasureComponentState {
	show: boolean;
}

/**
 * @Shortcode
 *
 * @title "Kereső mező"
 * @shortcode "search_form"
 * @type "widget"
 * @lazyHydrate "whenIdle"
 * @importMode "eager"
 */
export class SearchForm extends MeasureComponent<Props, State> {
	protected productTypes = "";
	protected readonly componentType: EventComponentType = "widget";

	protected getInitialState(): State {
		return { ...super.getInitialState(), show: false };
	}

	public render(): ReactNode {
		const { search } = this.props;
		const { show } = this.state;

		return (
			<>
				<a
					className="search search-button cursor-pointer"
					href="#"
					role="button"
					onClick={this.onClick}
					title="Kereső"
					aria-label="Kereső"
				>
					<FontAwesomeIcon
						icon={fasMagnifyingGlass}
						fixedWidth
						style={{ width: "23px", display: "inline-block" }}
					/>
				</a>
				{show && (
					<LazyLoad>
						<SearchModal show={show} onHide={this.onClick} search={search} />
					</LazyLoad>
				)}
			</>
		);
	}

	@autobind
	protected onClick(): void {
		const { show, wasVisible } = this.state;

		this.setState({ show: !show });

		if (!wasVisible) {
			this.onVisibilityChange(!show);
		}
	}

	protected getComponentName(): string {
		return "SearchForm";
	}
}

export default SearchForm;
